/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopItemCategory = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopItemCategory model module.
   * @module model/WorkshopItemCategory
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopItemCategory</code>.
   * @alias module:model/WorkshopItemCategory
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>WorkshopItemCategory</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopItemCategory} obj Optional instance to populate.
   * @return {module:model/WorkshopItemCategory} The populated <code>WorkshopItemCategory</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IsSubcategory')) {
        obj['IsSubcategory'] = ApiClient.convertToType(data['IsSubcategory'], 'Boolean');
      }
      if (data.hasOwnProperty('CardColor')) {
        obj['CardColor'] = ApiClient.convertToType(data['CardColor'], 'String');
      }
      if (data.hasOwnProperty('WidgetID')) {
        obj['WidgetID'] = ApiClient.convertToType(data['WidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} IsSubcategory
   * @default false
   */
  exports.prototype['IsSubcategory'] = false;
  /**
   * @member {String} CardColor
   * @default ''
   */
  exports.prototype['CardColor'] = '';
  /**
   * @member {Integer} WidgetID
   * @default 0
   */
  exports.prototype['WidgetID'] = 0;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


